import clsx from 'clsx';
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';

const variants = {
  success: {
    bg: 'bg-success/10 border-success/20',
    text: 'text-success-dark',
    icon: CheckCircle,
  },
  error: {
    bg: 'bg-error/10 border-error/20',
    text: 'text-error-dark',
    icon: XCircle,
  },
  warning: {
    bg: 'bg-warning/10 border-warning/20',
    text: 'text-warning-dark',
    icon: AlertCircle,
  },
  info: {
    bg: 'bg-info/10 border-info/20',
    text: 'text-info-dark',
    icon: Info,
  },
};

export default function Alert({ variant = 'info', children, className = '' }) {
  const { bg, text, icon: Icon } = variants[variant];

  return (
    <div className={clsx('flex items-start gap-3 p-4 rounded-lg border', bg, className)}>
      <Icon className={clsx('w-5 h-5 flex-shrink-0 mt-0.5', text)} />
      <div className={clsx('text-sm', text)}>{children}</div>
    </div>
  );
}
